<template>
    <div id="accordionExample" class="accordion flex flex-col gap-2.5 pl-[0.5rem] w-full">
        <div
v-for="(item, index) in accordionItems"
            :key="index" class="accordion-item shadow-[0px_0px_10px_0px_#00000026] !rounded-[10px] overflow-hidden"
            :class="{ '!border-purple-500': activeIndex === index }" :style="{ border: index === 0 ? '1px solid #fff' : '1px solid #fff' }"
>
            <h2 :id="'heading' + index" class="accordion-header">
                <!--:class="{ collapsed: activeIndex !== index, '!shadow-none !text-fuchsia-700': activeIndex === index }"  -->
                <button
                    class="accordion-button p-2.5 bg-transparent !border-0 focus:!outline-none focus:!shadow-none after:hidden w-full text-left relative !text-[#9336B4]"
                    type="button" :aria-expanded="activeIndex === index ? 'true' : 'false'"
                    @click="activeIndex = activeIndex === index ? null : index"
>
                    {{ item.title }}
                    <font-awesome-icon
icon="angle-down" :class="[
                        'absolute right-4 top-1/2 transform -translate-y-1/2 transition-transform',
                        activeIndex === index ? 'rotate-180 text-purple-500' : 'text-purple-500'
                    ]"
/>
                </button>
</h2>
            <transition name="accordion">
                <div
v-show="activeIndex === index" class="accordion-body p-2.5 pt-0" :class="item.class"
                    v-html="item.content"
/>
            </transition>
        </div>
    </div>
</template>


<script>
export default {
    props: {
        items: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            activeIndex: 0,
        };
    },
    computed: {
        accordionItems() {
            return this.items;
        },
    },
    watch: {
        items: {
            handler() {
                this.activeIndex = null; 
            },
            deep: true,
            immediate: true,
        },
    }
};

</script>
